var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecurringModalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3133 27.875H27.1807C26.3371 27.875 25.5281 28.2101 24.9316 28.8066C24.3351 29.4031 24 30.2121 24 31.0557V53.3208C24 54.1644 24.3351 54.9734 24.9316 55.5699C25.5281 56.1664 26.3371 56.5015 27.1807 56.5015H49.4458C50.2894 56.5015 51.0984 56.1664 51.6949 55.5699C52.2914 54.9734 52.6265 54.1644 52.6265 53.3208V42.1883",
    stroke: "#1F61DC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2418 25.4881C50.8745 24.8554 51.7326 24.5 52.6273 24.5C53.5221 24.5 54.3802 24.8554 55.0129 25.4881C55.6456 26.1208 56.001 26.9789 56.001 27.8737C56.001 28.7684 55.6456 29.6265 55.0129 30.2592L39.9044 45.3677L33.543 46.958L35.1333 40.5966L50.2418 25.4881Z",
    stroke: "#1F61DC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.5,
    r: 37.5,
    stroke: "#1F61DC",
    strokeWidth: 5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurringModalIcon);
export default __webpack_public_path__ + "static/media/RecurringModalIcon.55ae3405ece832f175ad964f8b11b51a.svg";
export { ForwardRef as ReactComponent };